
    <div class="container">
      <div class="row">
        <ul class="footerList col">
          <li class="title" translate="lblServiceActivities">
            <strong>Service Activities</strong>
          </li>
          <li *ngFor="let link of exploreLinks">
            <a
              href=""
              [routerLink]="link.route"
              [translate]="link.translationKey"
              >{{ link.label }}</a
            >
          </li>
        </ul>
        <ul class="footerList col">
          <li class="title" translate="lblResources">
            <strong>Resources</strong>
          </li>
          <li *ngFor="let link of resourcesLinks">
            <a
              *ngIf="link.route"
              [routerLink]="link.route"
              target="_blank"
              [translate]="link.translationKey"
              >{{ link.label }}</a
            >
            <a
              *ngIf="link.click"
              href
              (click)="link.click($event)"
              [translate]="link.translationKey"
              >{{ link.label }}</a
            >
            <a
              *ngIf="link.direct"
              (click)="reloadZendesk(link.reloadZendesk)"
              [href]="link.direct"
              target="_blank"
              [translate]="link.translationKey"
              >{{ link.label }}</a
            >
          </li>
        </ul>
        <div class="footerBranding col">
          <div class="title">Lions Clubs International</div>
          <div class="address">
            300 W. 22nd Street <br />
            Oak Brook, IL 60523-8842 USA
          </div>
          <div class="telephone">+1 (630) 468-6900</div>
        </div>
      </div>
    </div>
  